import React, { Component } from 'react';
import { TableDefault } from '../../../../components';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: null,
      urlEdit: '/admin/gestao/budget/',
      urlLoad: '/Orcamento/GetListagem/',     
    };
  }

  render() {
    const {
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad
    } = this.state;

    const { type } = this.props;
    return (
      <div>
        <TableDefault
          search={search}
          type={type}
          order={order}
          orderBy={orderBy}
          pageSize={pageSize}
          totalItems={totalItems}
          urlDelete={urlDelete}
          urlEdit={urlEdit}
          urlLoad={urlLoad}
        />
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/CategoryModels/List/List.jsx